import { render, staticRenderFns } from "./AdsCategory.vue?vue&type=template&id=292e5a5c&scoped=true&"
import script from "./AdsCategory.vue?vue&type=script&lang=js&"
export * from "./AdsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292e5a5c",
  null
  
)

export default component.exports